
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m4.26231 20.3995c-.21483.0011-.41622-.1033-.54016-.278-.12394-.1757-.15596-.3999-.08469-.6025l1.14433-3.2377h.00103c-1.3953-2.3573-1.55436-5.2468-.42655-7.74264 1.12884-2.49577 3.40199-4.28458 6.09253-4.79307 2.6894-.50743 5.4584.32864 7.4186 2.24156 1.9593 1.91291 2.864 4.66185 2.423 7.36535-.441 2.7036-2.1709 5.0225-4.6362 6.213-2.4663 1.1905-5.3572 1.1027-7.746-.2346l-3.45566 1.0428c-.06197.0175-.126.0268-.19004.0258zm3.73031-2.4472c.12084.0011.23961.0341.3429.0982 2.00778 1.2226 4.48948 1.3724 6.62948.401 2.14-.9715 3.6624-2.938 4.0661-5.254.4039-2.3159-.3625-4.68244-2.048-6.32166-1.6845-1.63904-4.0704-2.33867-6.3725-1.86847-2.30311.46918-4.22503 2.04726-5.13402 4.21553-.9099 2.1682-.68992 4.6454.58767 6.6193.12497.1881.14563.4269.05577.6346l-.79319 2.2673 2.48284-.7482v-.001c.05887-.0217.11981-.0362.18281-.0424z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    